import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ActionBarComponent } from './action-bar/action-bar.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ActionBarComponent
    ],
    exports: [
        CommonModule,
        RouterModule,
        ActionBarComponent
    ]
})
export class SharedModule { }
